// src/components/search/recipe-item/index.jsx

import React from 'react'; // Make sure React is imported for React.memo
import './styles.css';

const RecipeItem = ({ item, handleAddFavorites }) => {
    console.log(`Rendering RecipeItem: ${item.title}`); // You can use this to see renders
    return (
        <div className="recipe-item">
            <img src={item.image} alt={item.title} />
            <h3>{item.title}</h3>
            <button
                type="button"
                onClick={() => handleAddFavorites(item)}
                className="button"
            >
                Add to Favorites
            </button>
        </div>
    );
};

export default React.memo(RecipeItem); // Wrap your component with React.memo